import axios from "axios";
import { OnboardConfirm } from "../types/OnboardConfirm";
import { CurrentUserInterface } from "../types/User";

export async function postSignIn(email: string, password: string) {
  const resp = await axios.post("/sherpa/v0/auth/users/sign_in", {
    email,
    password,
  });

  return resp.data;
}

export async function signOutUser() {
  const resp = await axios.get("/sherpa/v0/auth/users/sign_out");
  return resp.data;
}

export async function getCurrentUser() {
  const resp = await axios.get<{ data: CurrentUserInterface }>(
    "/sherpa/v0/auth/users/current"
  );
  return resp.data;
}

export async function validateToken(token: string) {
  const response = await axios.get(
    "/sherpa/v0/api/invitations/valid?token=" + token
  );
  return response.data;
}
export async function clientOnboard(data: OnboardConfirm) {
  const response = await axios.post<{}>(
    "/sherpa/v0/api/accounts/onboard/confirm",
    data
  );
  return response;
}
